import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import "../../utils/Style/component/modals.scss";
import { useDispatch, useSelector } from 'react-redux';
import DeleteEmployeePopup from './DeleteEmployeePopup';
import { setShowDeleteEmployeePopup, setShowEmployeeDetailsPopup } from '../../features/employeeSlice';
import useEmployeesApi from '../../api/EmployeesApi';
import { setActionPayload, setActionType } from '../../features/authorizationSlice';
import { ACTION_TYPES } from '../../app/actionTypes';
import { useOutletContext } from 'react-router-dom';

function EmployeeDetailsPopup() {

    const employeeDetails = useSelector(state => state.employees.employeeDetails)
    const allEmployee = useSelector(state => state.employees.allEmployees)
    const showEmployeeDetailsPopup = useSelector(state => state.employees.showEmployeeDetailsPopup);
    const showDeleteEmployeePopup = useSelector(state => state.employees.showDeleteEmployeePopup);
    const [edit, setEdit] = useState(false);
    const [modalOpen, setModalOpen] = useState(false)
    const [selectedPosition, setSelectedPosition] = useState("")
    const [errors, setErrors] = useState({});
    const [roles, setRoles] = useState([]);
    const dispatch = useDispatch();

    const { GetEmployeesRoles, employeeRole, EditEmployee } = useEmployeesApi();
    const [onOpenQrAfterGenerate]  = useOutletContext();


    useEffect(() => {
      GetEmployeesRoles();
    }, [])

    const handleCloseModal = () => {
      dispatch(setShowEmployeeDetailsPopup(false));
  };


    useEffect(() => {
      setRoles(employeeRole)
    }, [employeeRole])

    const handleDelete = () => {
      dispatch(setShowDeleteEmployeePopup(true));
      // dispatch(setShowEmployeeDetailsPopup(false));
      
  };
  
  const handleEdit = () => {
    setEdit(true); 
  }

  const handleSave = () => {
    if (validateForm()) {
        const selectedRole = roles.find(role => String(role.value) === String(selectedPosition));

        setErrors({});
        setEdit(false);
        dispatch(setShowEmployeeDetailsPopup(false))
        const selectedEmployee = allEmployee.find(employee => employee.name === employeeDetails.EmployeeName);

        const payload = {
            employeeID: selectedEmployee ? selectedEmployee.id : null,
            roleID: selectedRole ? selectedRole.value : selectedEmployee ? selectedEmployee.role : null, 
        };

        dispatch(setActionType(ACTION_TYPES.EDIT_EMPLOYEE));
        dispatch(setActionPayload(payload));

        onOpenQrAfterGenerate();
    }
};

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if(!selectedPosition) {
      newErrors.Position = "Position is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  }

    return (
    <Modal centered show={showEmployeeDetailsPopup} onHide={handleCloseModal}>
      <Modal.Body>
        <div className="mobile-confirmation-modal">
          <div className="header-employee-popup">
            <div className='title'>Employee Details</div>
            <div className='close' onClick={handleCloseModal}>X</div>
          </div>
          <div className="response-message employee-details">
            <div className='employees-information'>
              <div className='row-details'>
                <div className='label'>Name</div>
                <div className='value'>{employeeDetails.EmployeeName}</div>
              </div>
              <div className='row-details'>
                <div className='label'>Position</div>
                <div className='value'>
                  {edit ? (
                    <>
                      <select
                        className='select'
                        defaultValue={employeeDetails.Position}
                        onChange={(e) => setSelectedPosition(e.target.value)}
                      >
                        <option value="">Select Position</option>
                        {roles.map(role => (
                          <option key={role.value} value={role.value}>
                            {role.label}
                          </option>
                        ))}
                      </select>
                      {errors.Position && <div className="error-popup">{errors.Position}</div>}
                    </>
                  ) : (
                    employeeDetails.Position
                  )}
                </div>
              </div>
              <div className='row-details'>
                <div className='label'>Phone Number</div>
                <div className='value'>{employeeDetails.PhoneNumber}</div>
              </div>
              <div className='row-details'>
                <div className='label'>Email</div>
                <div className='value'>{employeeDetails.Email}</div>
              </div>
            </div>
            <div className='buttons'>
            <div className='buttons'>
                            {edit ? (
                                <div className='edit-detail'>
                                    <button className='edit-button' onClick={handleSave}>Save</button>
                                </div>
                            ) : (
                                <>
                                    <div className='edit-details'>
                                        <button className='edit-button' onClick={handleEdit}>Edit Details</button>
                                    </div>
      
                                </>
                            )}
                        </div>
                <div className='delete-employee'>
                    <button className='delete-button' onClick={handleDelete}>Delete Employee</button>
                </div>
            </div>
          </div>
  
          {showDeleteEmployeePopup && 
            <DeleteEmployeePopup />
          }
            
        
        </div>
      </Modal.Body>
    </Modal>
  )
}


export default EmployeeDetailsPopup;
